import { render } from "./PatientNationalityField.vue?vue&type=template&id=b1e807d4"
import script from "./PatientNationalityField.vue?vue&type=script&lang=js"
export * from "./PatientNationalityField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__